export default __webpack_public_path__ + "static/media/javascript-08.1a8b02f4.png";